import React from 'react';

interface SpinnerProps {
  size?: number;
  className?: string;
}

/**
 * Spinner único e compartilhado — antes existiam pelo menos 4 implementações
 * diferentes de "carregando" espalhadas pelo código (SVG customizado
 * duplicado em vários modais, div com animate-spin reinventada à mão em
 * outros lugares, CircularProgress do MUI em outros). Usar um só componente
 * garante a mesma aparência em qualquer lugar do sistema.
 */
const Spinner: React.FC<SpinnerProps> = ({ size = 24, className = '' }) => (
  <svg
    className={`animate-spin text-bravo-primary ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="status"
    aria-label="Carregando"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
);

export default Spinner;
